import { jsx, type JsxElementProps } from '@amazon/vinyl-tsx'
import type { JsxChild } from '@amazon/vinyl-tsx'
import { type NavigateOptions, navigateTo } from '@/router/router'
import { asData } from '@amazon/vinyl-observable'

export type LinkProps = JsxElementProps<'a'> & {
    readonly navigateOptions?: NavigateOptions
}

export function Link(props: LinkProps, children: readonly JsxChild[]) {
    const { navigateOptions, ...rest } = props
    const href = asData(rest.href)
    return (
        <a
            {...rest}
            onclick={(e) => {
                // Only intercept SPA navigation.
                if (href.value == null || !href.value.startsWith('/')) return
                // Ignore modifier clicks or non-left clicks
                if (
                    e.defaultPrevented ||
                    e.button !== 0 ||
                    e.metaKey ||
                    e.ctrlKey ||
                    e.shiftKey ||
                    e.altKey
                ) {
                    return
                }
                e.preventDefault()
                navigateTo(href.value, navigateOptions)
            }}
        >
            {...children}
        </a>
    )
}
